/****************************************************
 * Module Name:  NivodaUserProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class NivodaUserProxy {

    static GetAllNivodaUser = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/user",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetNivodaUserByUser = (nivodaUser, callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/nivoda/user/${nivodaUser}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetAllDistinctNivodaUser = (callback) => {
        restAPICall(
            Constants.UTILITY_URL + `/nivoda/user/distinct`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckNivodaUserAvailable = (nivodaUser, callback) => {

        restAPICall(
            Constants.UTILITY_URL + `/nivoda/user/available/${nivodaUser}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddNivodaUser = (nivodaUser, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/user",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(nivodaUser),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateNivodaUser = (nivodaUser, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/user",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(nivodaUser),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteNivodaUser = (nivodaUser, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/user",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(nivodaUser),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
